import { Logger } from '../../generic/utils';
import { useEffect } from 'react';
import { wrapperIdentifier } from '../../wrappers/ApplicationWrapper/common';
import { wrapperBuilder } from './build';

const console = new Logger(wrapperIdentifier);

if (console) {
  //Just for usage
}
const logic = wrapperBuilder.getCustomLogicRegisterInstance();

logic.setLogic(
  ({
    functions: { loadUserEnvelopes },
    bindedContexts: { user },
    variablesHandler: {
      variablesSetter,
      variables: { envelopes },
    },
  }) => {
    const userId = user && (user._id || user.id);

    useEffect(() => {
      if (userId) {
        console.log('Loading envelopes');
        loadUserEnvelopes(userId);
      } else if (!userId) {
        if (envelopes) {
          variablesSetter('envelopes')(undefined);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);
  }
);
